import { BAOCustomElement } from '@bao/custom-element'

class AnimateIn extends BAOCustomElement() {
  connectedCallback () {
    if (Shopify.designMode) return

    super.connectedCallback()

    this.splitWords()

    if (this.useObserver) {
      this.observer = new IntersectionObserver(this.onEntry.bind(this), {
        rootMargin: '0px 0px -20% 0px',
        threshold: 0.2,
      })

      this.observer.observe(this)
    }
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.setAttribute('animate', '')

    observer.unobserve(this)
  }

  splitWords () {
    if (!this.els?.title?.exists) return

    this.els.title.elements.forEach((titleEl) => {
      const text = titleEl.innerText
      const lines = text.split('\n')

      let titleContent = ''
      let wordIndex = 0

      lines.forEach((line, lineIndex) => {
        const words = line.trim().split(/\s+/)

        words.forEach((word) => {
          const delay = wordIndex * 0.4

          titleContent += `
          <span
            class="ani-Title_Word"
            style="--word-delay: ${delay}s;"
            aria-hidden="true"
          >
            ${word}
          </span>
        `

          wordIndex += 1
        })

        if (lineIndex < lines.length - 1) {
          titleContent += '<br>'
        }
      })

      titleEl.innerHTML = titleContent
    })
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.observer && this.useObserver) {
      this.observer.disconnect()
      this.observer = null
    }
  }

  get useObserver () {
    return this.dataset.useObserver === 'true' || !this.dataset.useObserver
  }
}

if (!customElements.get('animate-in')) {
  customElements.define('animate-in', AnimateIn)
}
